import { type CSSProperties } from 'typestyle/lib/types';

const divider: CSSProperties = {
  marginLeft: 4,
  marginRight: 4,
  color: 'black'
};

export default divider;
